export default __webpack_public_path__ + "static/media/Frosch-mit-Pilzen.9e655669.webp";